import {Heading} from 'cdk-radial';
import EmptyStateCard from "../common/EmptyStateCard";
import BannerContainer from "../campaign/BannerContainer";
import OutageNotificationContainer from '../notification/OutageNotificationContainer';
import { useTranslation } from "react-i18next";
import AhaWidget from '../third-party-integration/aha/AhaWidget';
import {AhaPilotWidget} from '../third-party-integration/aha/AhaPilotWidget';
import '../dashboard/Dashboard.css';
import { ErrorBoundary } from '../../util/ErrorBoundary';
import { DomainTabs } from '../dashboard/DomainTabs';
import { useEffect } from 'react';

export function FavoriteDashboardContainer() {
  return (
    <>
        <EmptyStateCard isApplication={true} isUserCard={false} />
    </>
  );
}

export function DashboardContainer() {
  const { t } = useTranslation();

  useEffect(() => {
    return () => {
      const wrappers = document.querySelectorAll('.recharts-wrapper');
      wrappers.forEach(wrapper => {
        const emptyClone = wrapper.cloneNode(false);
        wrapper.parentNode?.replaceChild(emptyClone, wrapper);
        emptyClone.parentNode?.removeChild(emptyClone);
      });
    };
  }, []);

  return (
      <div style={{maxWidth:'1664px', marginBottom:'20px'}}>
      <OutageNotificationContainer/>
      <BannerContainer/>
       <div style={{display: 'flex','justifyContent': 'space-between','flexDirection': 'row' , 'marginBottom':'10px', 'marginTop':'10px'}}>
          <Heading type="subtitle-1" level={6}>
              {t("myUnifyTab.dashboards")}
          </Heading>
          
        <div style={{display: 'flex', gap: '10px'}}>
          <div style={{display: 'flex'}}>
            <AhaWidget></AhaWidget>
          </div>
          <div style={{display: 'flex'}}>
              <AhaPilotWidget></AhaPilotWidget>
          </div>
        </div>
      </div>

      <ErrorBoundary>
        <div key={window.location.pathname}>
            <DomainTabs></DomainTabs>
        </div>

      </ErrorBoundary>

    </div>
  );
}

export default DashboardContainer;
